/**
 * Eén bron voor de fotolimieten. Label, teller, hulptekst én de daadwerkelijke
 * grens lezen hier allemaal uit, zodat ze elkaar niet meer kunnen tegenspreken.
 * Gelijk aan wat de app zelf toestaat (OnboardingScreen.js: maxPhotos = 5).
 */
export const MAX_PROFILE_IMAGES = 5;
export const MAX_ROOM_IMAGES = 5;

/** Aantal reacties dat het dashboard per keer toont ("Toon meer"). */
export const MATCHES_PAGE_SIZE = 15;

/**
 * Google Places — dezelfde instellingen als de app (`app/components/LocationInput.js`),
 * zodat suggesties en het gekozen adres identiek zijn.
 * De sleutel is overschrijfbaar met VITE_GOOGLE_MAPS_API_KEY (Vercel / .env.local),
 * zodat localhost en productie een eigen, apart beperkte sleutel kunnen gebruiken.
 */
export const GOOGLE_MAPS_API_KEY =
  import.meta.env.VITE_GOOGLE_MAPS_API_KEY || 'AIzaSyDok5wo61K7x3UjXqoerfjcitr-xH3bluo';
export const PLACES_LANGUAGE = 'nl';   // app: language=nl
export const PLACES_COUNTRY = 'nl';    // app: components=country:nl
export const PLACES_DEBOUNCE_MS = 300; // app: debounce: 300
export const PLACES_MAX_RESULTS = 5;   // app: mergedResults.slice(0, 5)
